<template>
  <section class="not-found grid center cross-center">
    <div class="container">
      <div class="not-found__wrapper">
        <div class="text-center">
          <h1 class="title u-16">Страница не найдена</h1>
          <p class="u-16">
            <router-link to="/">Вернитесь на страницу с заказами</router-link>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import notFound from "@/assets/images/404.png";
export default {
  name: "NotFound"
};
</script>

<style lang="sass">
.not-found
  height: 100%
</style>